import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { 
  IonHeader, 
  IonToolbar, 
  IonTitle, 
  IonContent, 
  IonButton, 
  IonCheckbox, 
  IonSpinner,
  IonText,
  ModalController
} from '@ionic/angular/standalone';
import { EulaService, EULAStatus } from '../../services/eula.service';
import { LoggerService } from '../../services/logger.service';

@Component({
  selector: 'app-eula-modal',
  templateUrl: './eula-modal.component.html',
  styleUrls: ['./eula-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButton,
    IonCheckbox,
    IonSpinner,
    IonText
  ]
})
export class EulaModalComponent implements OnInit {
  eulaContent: string = '';
  isLoading: boolean = true;
  isAccepting: boolean = false;
  hasAcceptedCheckbox: boolean = false;
  errorMessage: string = '';

  constructor(
    private modalController: ModalController,
    private eulaService: EulaService,
    private logger: LoggerService
  ) {}

  async ngOnInit() {
    await this.loadEULAContent();
  }

  async loadEULAContent() {
    try {
      this.isLoading = true;
      this.eulaContent = await this.eulaService.getEULAContent();
    } catch (error) {
      this.logger.error('Error loading EULA content:', error);
      this.errorMessage = 'Failed to load EULA content. Please try again.';
    } finally {
      this.isLoading = false;
    }
  }

  async acceptEULA() {
    if (!this.hasAcceptedCheckbox) {
      this.errorMessage = 'You must accept the EULA to continue.';
      return;
    }

    try {
      this.isAccepting = true;
      this.errorMessage = '';

      await this.eulaService.acceptEULA().toPromise();
      
      // Close modal with success
      this.modalController.dismiss({ accepted: true });
    } catch (error) {
      this.logger.error('Error accepting EULA:', error);
      this.errorMessage = 'Failed to accept EULA. Please try again.';
    } finally {
      this.isAccepting = false;
    }
  }

  declineEULA() {
    // Close modal with decline
    this.modalController.dismiss({ accepted: false });
  }

  onCheckboxChange(event: any) {
    this.hasAcceptedCheckbox = event.detail.checked;
    if (this.hasAcceptedCheckbox) {
      this.errorMessage = '';
    }
  }
} 